// Generics
export const LOCATION = 'Location';
export const INSTRUCTORS = 'Instructor(s)';
export const DATE = 'Date';
export const FORMS = 'Forms';
export const TEAMS = 'Teams';
export const NAME = 'Name';
export const PHONE = 'Phone';
export const ADDRESS = 'Address';
export const NOTES = 'Enter additional information here.'

// Emergency Response Plan
export const FIRST_AID_KIT_LOCATION = 'First Aid Kit Location';
export const DESIGNATED_FIRST_AIDERS = 'First Aiders';
export const MUSTER_POINT = 'Muster Point';
export const NEAREST_HOSPITAL = 'Nearest Hospital';
export const SEARCH_AND_RESCUE = 'Search and Rescue';
export const LOCAL_GOV_CONTACT = 'Local Government Contact';
export const SITE_CONTACT = 'Site Contact';

// Safety Tailgate Form
export const HAZARDS = 'Hazards';
export const CONTROL_MEASURES = 'Control Measures';
export const EMERGENCY_RESPONSE_PLAN = 'Emergency Response Plan';
export const START_TIME = 'Start Time';
export const NEAR_MISS = 'Near Miss';
export const INCIDENT = 'Incident';
export const NEARMISS_PLACEHOLDER = 'Include date/time/description of event';

// Hazards
export const BIO_HAZARDS = 'Biological Hazards';
export const BEES_WASPS = 'Bees / Wasps';
export const BOATING = "Boating";
export const CUTS_ABRASIONS_STRAINS = 'Cuts / Abrasions / Strains';
export const CHEMICAL_HAZARDS = 'Chemical Hazards';
export const DISTRACTED_DRIVING = 'Distracted Driving';
export const DEHYDRATION = 'Dehydration';
export const OBJ_IN_EYE = 'Dirt / Object in Eye';
export const EQUIPMENT_USE = 'Equipment Use';
export const FATIGUE = 'Fatigue';
export const NOXIOUS_PLANTS = 'Noxious Plants';
export const NAVIGATION_LOST = 'Navigation / Lost';
export const NOISE = 'Noise';
export const OVERHEAD_HAZARDS = 'Overhead Hazards';
export const PANDEMIC_ILLNESS = 'Pandemic / Illness';
export const REMOTE_AREA = 'Remote Area';
export const ROAD_CONDITIONS = 'Road Conditions';
export const SLIPS_TRIPS_FALLS = 'Slips / Trips / Falls';
export const SWIFT_WATER = "Swift Water";
export const TRA_VEH_MACHINERY = 'Traffic / Vehicles / Machinery';
export const WILDLIFE_DOGS = 'Wildlife & Dogs';
export const WEATHER_EXPOSURE = 'Weather Exposure (hot/cold)';
export const WORKING_WATER = 'Working In / Near Water';

// Control Measures
export const APPROPRIATE_CLOTHING = 'Appropriate Clothing';
export const BEAR_SPRAY = "Bear Spray";
export const BUG_SPRAY = 'Bug Spray';
export const BOAT_SAFETY_KIT = "Boat Safety Kit";
export const CAULK_BOOTS = 'Caulk Boots';
export const COMM_PLAN = 'Communication Plan';
export const EAR_PROTECTION = 'Ear Protection';
export const EPIPEN = 'EpiPen';
export const FIRST_AID_KIT = 'First Aid Kit';
export const GLOVES = 'Gloves';
export const GPS_MAP = 'GPS / Map';
export const HARD_HAT = 'Hard Hat';
export const HAND_RADIOS = 'Hand Radios';
export const HAND_SAN_WIPES = 'Hand Sanitizer / Wipes';
export const HI_VIS_VEST = "Hi Vis Vest";
export const IN_REACH_SPOT = 'In Reach / Spot';
export const LIFE_JACKET = 'Life Jacket';
export const MASK = 'Mask';
export const MAKE_NOISE = "Make Noise";
export const MANAGE_ATTRACTANTS = "Manage Attractants";
export const RESOURCE_MATERIAL = 'Resource Material';
export const STEEL_TOED_BOOTS = 'Steel Toed Boots';
export const STURDY_FOOTWEAR = "Sturdy Footwear";
export const SIGNAGE = 'Signage';
export const SAFETY_GOGGLES = 'Safety Goggles';
export const THROW_LINE = 'Throw Line';
export const WHISTLE = 'Whistle';
export const WATER = 'Water';
export const WADERS = "Waders with Belt";
export const WADING_STAFF = "Wading Staff";
export const WORK_IN_GROUPS = "Work in Groups";


export const HAZARDS_ARRAY = [
    BEES_WASPS, BOATING, BIO_HAZARDS,
    CHEMICAL_HAZARDS, CUTS_ABRASIONS_STRAINS,
    DEHYDRATION, DISTRACTED_DRIVING,
    EQUIPMENT_USE,
    FATIGUE,
    NAVIGATION_LOST, NOISE, NOXIOUS_PLANTS,
    OBJ_IN_EYE, OVERHEAD_HAZARDS,
    PANDEMIC_ILLNESS,
    REMOTE_AREA, ROAD_CONDITIONS,
    SLIPS_TRIPS_FALLS, SWIFT_WATER,
    TRA_VEH_MACHINERY,
    WEATHER_EXPOSURE, WILDLIFE_DOGS, WORKING_WATER];

export const CONTROL_MEASURES_ARRAY = [
    APPROPRIATE_CLOTHING,
    BOAT_SAFETY_KIT, BEAR_SPRAY, BUG_SPRAY,
    CAULK_BOOTS, COMM_PLAN,
    EAR_PROTECTION, EPIPEN,
    FIRST_AID_KIT,
    GLOVES, GPS_MAP,
    HAND_RADIOS, HAND_SAN_WIPES, HARD_HAT, HI_VIS_VEST,
    IN_REACH_SPOT,
    LIFE_JACKET,
    MASK, MAKE_NOISE, MANAGE_ATTRACTANTS,
    RESOURCE_MATERIAL,
    SAFETY_GOGGLES, SIGNAGE, STEEL_TOED_BOOTS, STURDY_FOOTWEAR,
    THROW_LINE,
    WATER, WHISTLE, WADERS, WORK_IN_GROUPS, WADING_STAFF];